import { render, staticRenderFns } from "./StripePaymentRequestButton.vue?vue&type=template&id=134ce9ee&scoped=true&"
import script from "./StripePaymentRequestButton.vue?vue&type=script&lang=js&"
export * from "./StripePaymentRequestButton.vue?vue&type=script&lang=js&"
import style0 from "./StripePaymentRequestButton.vue?vue&type=style&index=0&id=134ce9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ce9ee",
  null
  
)

export default component.exports